import FormField from "./FormField";

const CheckboxField = ({ label, name, checked, onChange, description }) => (
  <FormField label={null} description={description}>
    <div className="flex items-center space-x-2">
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 focus:ring-offset-2 focus:ring-2"
      />
      <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-gray-700">
        {label}
      </label>
    </div>
  </FormField>
);

export default CheckboxField;
